// extracted by mini-css-extract-plugin
export default {"name":"modal-header_name__BPKU4"};